import React, { useState, useEffect, useRef } from "react";
import { Dimmer } from "../../spinner";
import { EnhancedTableHead, formatMoneda } from "../../../util/varios";
import "react-tabs/style/react-tabs.css";
import moment from "moment";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../mensajes2";
import * as XLSX from "xlsx";
import { ActualizarPagosWeb } from "./modalActualizarPagoWeb";
import { ModalBancamiga } from "./modalConsultarBancamiga";

function TablaVerificarPagosEstadoCuenta() {
  const op = require("../../../modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusu = localStorage.getItem("idusuario");

  const headCells = [
    { label: "Contribuyente", textAlign: "center" },
    { label: "Rif", textAlign: "center" },

    { label: "Cuenta Bancaria", textAlign: "center" },
    { label: "Documento", textAlign: "center" },
    { label: "Tipo", textAlign: "center" },
    { label: "Fecha Pago", textAlign: "center" },
    { label: "Monto", textAlign: "center" },
    { label: "Factura", textAlign: "center" },
    { label: "Periodo", textAlign: "center" },
    { label: "Fecha Operación", textAlign: "center" },
    { label: "Opción", textAlign: "center" },
  ];

  const btnCancela = useRef();
  const txtTotal = useRef("0,00");
  const cmbTipoImpuesto = useRef();
  const cmbCuentaBan = useRef();
  const txtFechaDesde = useRef();
  const txtFechaHasta = useRef();
  const radioTodosDias = useRef();
  const radioSeleccionarFecha = useRef();
  const txtFile = useRef();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [configCome, setConfigCome] = useState();
  const [recordsArray, setRecordsArray] = useState([]);
  const [encontrados, setEncontrados] = useState([]);
  const [noEncontrados, setNoEncontrados] = useState([]);
  const [referenciaCorta, setReferenciaCorta] = useState([]);
  const [noCoincide, setNoCoincide] = useState([]);
  const [habilitarApi, setHabilitarApi] = useState({
    show: false,
    modal: false,
    key: null,
    cliente_id: null,
    host: null,
  });
  const [liquidador, setLiquidador] = useState("");
  const [idusuario, setIdUsuario] = useState("");
  const [select2, setSelect2] = useState("0");
  const [cuentaBancaria, setCuentaBancaria] = useState();
  const [activo, setActivo] = useState(true);
  const [activo1, setActivo1] = useState(true);
  const [mostrar5, setMostrar5] = useState(false);
  const [activate, setActivate] = useState(false);
  const [data, setData] = useState();
  const [operacion, setOperacion] = useState(0);
  const [tipoImpuesto, setTipoImpuesto] = useState();
  const [desabilitarRows, setDesabilitarRows] = useState(false);
  const [desabilitarRows2, setDesabilitarRows2] = useState(false);
  const [verificacion, setVerificacion] = useState("");
  const [contar, setContar] = useState(0);
  const [tipoPago, setTipoPago] = useState();
  const [usuario, setUsuario] = useState();
  const [records, setRecords] = useState([]);
  const [respaldo, setRespaldo] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [isRecordsLoaded, setIsRecordsLoaded] = useState(false);
  const [selected, setSelected] = useState([]);
  const [factuSelected, setFactuSelected] = useState([]);
  const [disabletbtn, setDisabletbtn] = useState({
    consultar: false,
    verificar: false,
    rechazar: false,
    editar: false,
  });

  const handleRequestSort = (event, property) => {
    const isAsc = "calories" === property && "asc" === "asc";
  };

  const handleSelectAllClick = (event) => {
    if (verificacion !== 4) {
      if (event.target.checked) {
        const newSelecteds = records.map(
          (n) =>
            n.nrofactura.trim() +
            n.periodo.trim() +
            n.nrodocumento.trim() +
            n.monto.toString().trim(),
        );
        setSelected(newSelecteds);
        const newFacSelecteds = records.map((n) => n.nrofactura.trim());
        setFactuSelected(newFacSelecteds);
        sumarMontoFactura(newSelecteds);
        return;
      } else {
        setSelected([]);
        setFactuSelected([]);
        sumarMontoFactura([]);
      }
    }
  };

  const handleClick = (event, id, fact) => {
    if (verificacion !== 4) {
      const selectedIndex = selected.indexOf(id);
      const selectedFactIndex = factuSelected.indexOf(fact);
      let newSelected = [];
      let newFactSelected = [];

      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, id);
        newFactSelected = newFactSelected.concat(factuSelected, fact);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
        newFactSelected = newFactSelected.concat(factuSelected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
        newFactSelected = newFactSelected.concat(factuSelected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1),
        );
        newFactSelected = newFactSelected.concat(
          factuSelected.slice(0, selectedFactIndex),
          factuSelected.slice(selectedFactIndex + 1),
        );
      }

      setSelected(newSelected);
      setFactuSelected(newFactSelected);
      sumarMontoFactura(newSelected);
    }
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            x.contribuyente = x.contribuyente !== null ? x.contribuyente : "";

            if (
              x.cuentabancaria.includes(target.value) ||
              x.nrodocumento.includes(target.value.toLowerCase()) ||
              x.tipo.toLowerCase().includes(target.value.toLowerCase()) ||
              moment
                .utc(x.fecha)
                .format("DD/MM/YYYY")
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              formatMoneda(x.monto.toString().replace(".", ","), ",", ".", 2)
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.nrofactura.toLowerCase().includes(target.value.toLowerCase()) ||
              x.idcontribuyente.includes(target.value.toLowerCase()) ||
              /*    x.rif.includes(target.value.toLowerCase()) || */

              x.contribuyente
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.periodo.toLowerCase().includes(target.value.toLowerCase()) ||
              moment
                .utc(x.fecha)
                .format("DD/MM/YYYY")
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const onVerificar = () => {
    setDisabletbtn({
      ...disabletbtn,
      consultar: true,
      verificar: true,
      rechazar: true,
      editar: true,
    });
    setActivo1(false);
    setActivo(false);
    cmbTipoImpuesto.current.value = 1;
    seleccionarConfiguracion();
    setVerificacion(1);
    seleccionarTipoImpuesto();
  };

  const SelectCuentaBanco = () => {
    let endpoint = `${
      op.conexion
    }/api/Caja_Ingreso/selectallcuentabancarias?depositoweb=${true}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          app: "admin",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setActivate(false);
          if (response.data.length > 0) {
            setCuentaBancaria(response.data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const selectTipoImpu = (pagosweb) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/selectalltipoimpuesto?pagosweb=${pagosweb}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          app: "admin",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setTipoImpuesto(response.data);
            setContar(contar + 1);
            if (response.data.idtipoingreso) {
              if (cmbTipoImpuesto.current !== undefined) {
                cmbTipoImpuesto.current.value = response.data[0].idtipoingreso;
              }
            } else {
              if (cmbTipoImpuesto.current !== undefined) {
                cmbTipoImpuesto.current.value = response.data[0].idtipoingreso;
              }
              seleccionarPagosAVerificar(response.data[0].idtipoingreso);
            }
          } else {
            setTipoImpuesto([]);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const selectPagosVerify = (id, condic) => {
    setActivate(true);
    setIdUsuario(JSON.parse(localStorage.getItem("idusuario")));
    setRecords([]);
    setSelected([]);
    sumarMontoFactura([]);
    setEncontrados([]);
    setNoEncontrados([]);
    setReferenciaCorta([]);
    setNoCoincide([]);
    SelecccionarUsuario();

    const endpoint = `${op.conexion}/api/industria/selectpagosaverify?id=${id}&condic=${condic}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error?.response?.data?.message || "ERROR",
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const imprimirPlanilla = (idveri) => {
    let reporte = "";
    let verificador = liquidador === null ? "" : liquidador.trim();
    let cedula = "";
    let id = parseInt(idveri);
    let fact = "V" + id.toString().padStart(7, 0);
    let factura = fact;

    if (parseInt(espiritu) === 0) {
      reporte = "PlanillaAcarigua";
    } else if (parseInt(espiritu) === 9) {
      reporte = "PlanillaVerificacionAraure";
    } else if (parseInt(espiritu) === 11) {
      reporte = "PlanillaZamora";
    } else {
      reporte = "Planilla";
    }
    window.open(
      op.reportes +
        "/actividadeconomica?" +
        "reporte=" +
        reporte +
        "&VERIFICADOR=" +
        verificador +
        "&CEDULA=" +
        cedula +
        "&ID=" +
        id +
        "&FACTURA=" +
        factura,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  const seleccionarConfiguracion = () => {
    let endpoint = op.conexion + "/api/industria/configuracionindustria";
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setConfigCome(response.data);
          if (response.data.valorutMulta === null) {
            if (response.data.factormulta === 2) {
              setMensaje({
                mostrar: true,
                titulo: "Información.",
                texto:
                  "El valor de la unidad tributaria para el año " +
                  anioActu +
                  " no esta definido",
                icono: "exito",
              });
            } else if (response.data.factormulta > 2) {
              let tipo = response.data.factormulta - 3;

              setMensaje({
                mostrar: true,
                titulo: "Información.",
                texto:
                  "El valor del " +
                  (tipo === 0
                    ? "Petro"
                    : tipo === 1
                      ? "Sueldo Minimo"
                      : tipo === 2
                        ? "UCAMP"
                        : "") +
                  " para el año " +
                  anioActu +
                  " en el mes en curso no esta definido",
                icono: "exito",
              });
            }
          }
        }
      })
      .catch((error) => {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setActivate(false);
      });
  };

  const SelecccionarUsuario = () => {
    let campos = "*";
    let nomtab = "usuario";
    let nomid = "idusuario";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${parseInt(idusu.replace('"', "").replace('"', ""))}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          app: "admin",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idusuario > 0) {
            SelecccionarPersona(response.data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const SelecccionarPersona = (data) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.persona}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          app: "admin",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setUsuario(response.data);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const procesarVerificacion = (resagados, movi) => {
    // Validar que movi tenga datos
    if (!movi || movi.length === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "No hay movimientos para procesar",
        icono: "error",
      });
      return;
    }

    const endpoint = `${op.conexion}/api/Caja_Ingreso/actualizarverificacion/${verificacion}`;
    const body = {
      declaweb: Boolean(configCome?.declaweb?.toString() || false),
      fechasis: fechaSistema
        ? moment.utc(fechaSistema).format("YYYY-MM-DD")
        : moment.utc().format("YYYY-MM-DD"),
      movimientos: JSON.stringify(movi),
      tipoimpu:
        verificacion === 5
          ? "No definido"
          : cmbTipoImpuesto.current?.[cmbTipoImpuesto.current.selectedIndex]
              ?.text || "No definido",
    };

    setActivate(true);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          app: "admin",
          "Content-Type": "application/json",
        },
        timeout: 30000,
      })
      .then(function (response) {
        if (response.status === 200) {
          if (verificacion === 1) {
            const mensaje =
              resagados.length > 0
                ? `La Verificación con el Código ${response.data.idverifi} fue Verificada Correctamente y la(s) factura(s) ${resagados.map((f) => f.nrofactura).join(", ")} no fueron procesadas por tener más de un pago registrado y uno o varios de ellos no ser encontrados.`
                : `La Verificación con el Código ${response.data.idverifi} fue Verificada Correctamente.`;

            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: mensaje,
              icono: "exito",
            });
          }

          if (
            (verificacion === 1 || verificacion === 5) &&
            txtTotal?.current?.value !== "0,00"
          ) {
            imprimirPlanilla(response.data.idverifi);
          }
        }
        cancelar();
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error?.response?.data?.message || "ERROR",
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarTipoImpuesto = () => {
    setContar(0);
    selectTipoImpu(1);
  };

  const procesarSolicitud = () => {
    setContar(0);
    var veri = [];
    var resagados = [];

    // Si no hay respaldo (primera vez), usar records directamente
    const datosComparacion = respaldo.length > 0 ? respaldo : records;

    if (verificacion === 1 || verificacion === 2) {
      for (let x = 0; x < selected.length; x++) {
        for (let y = 0; y < records.length; y++) {
          if (
            records[y].nrofactura.trim() +
              records[y].periodo.trim() +
              records[y].nrodocumento.trim() +
              records[y].monto.toString().trim() ===
            selected[x]
          ) {
            // Usar datosComparacion en lugar de respaldo
            let coincidencias = datosComparacion.filter(
              (item) => item.nrofactura === records[y].nrofactura.trim(),
            );

            let coincidencias2 = records.filter(
              (item) => item.nrofactura === records[y].nrofactura.trim(),
            );

            // Modificar la condición para que sea más flexible
            if (coincidencias.length > 0 && coincidencias2.length > 0) {
              veri.push({
                idverificacion:
                  verificacion === 1 || verificacion === 2
                    ? 0
                    : records[y].idverificacion,
                idpagoweb: records[y].idpagoweb,
                idcuentabancaria: records[y].idcuentabancaria,
                fecha: moment(records[y].fecha).format("YYYY-MM-DD"),
                cuentabancaria: records[y].cuentabancaria.trim(),
                nrodocumento: records[y].nrodocumento.trim(),
                tipo: records[y].tipotransaccion,
                nrofactura: records[y].nrofactura.trim(),
                monto: records[y].monto,
                idcontribuyente: records[y].idcontribuyente,
                contribuyente:
                  records[y].contribuyente !== null
                    ? records[y].contribuyente
                    : "-",
                periodo: records[y].periodo.trim(),
                idverificador:
                  verificacion === 1 || verificacion === 2
                    ? idusuario
                    : records[y].idverificador,

                montototal:
                  txtTotal.current.value
                    .replace(/\./g, "")
                    .replace(",", ".") !== ""
                    ? txtTotal.current.value
                        .replace(/\./g, "")
                        .replace(",", ".")
                    : "0.00",
                fechaverificacion: fechaSistema,
                idfactura: records[y].idfactura,
                idtipoingreso: records[y].idtipoingreso,
                tabla: records[y].tabla.trim(),
                montomulta: records[y].montomulta,
                montorecargo: records[y].montorecargo,
                montointereses: records[y].montointereses,
                montoimpuesto: records[y].montoimpuesto,
                montodeducible: records[y].montodeducible,
                deudas:
                  records[y].idpublicidad === null
                    ? ""
                    : "'" + records[y].idpublicidad + "'",
                fecha: moment(records[y].fecha).format("YYYY-MM-DD"),
              });
            } else {
              resagados.push({
                nrofactura: records[y].nrofactura,
              });
            }
            break;
          }
        }
      }
    }

    if (veri.length === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "No hay registros seleccionados para procesar",
        icono: "error",
      });
      return;
    }

    procesarVerificacion(resagados, veri);
  };

  const onChangeValidar = () => {
    var sigue = true;
    if (verificacion === 1 || verificacion === 2 || verificacion === 5) {
      if (selected.length === 0 && (verificacion === 1 || verificacion === 2)) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Usted no ha marcado ningun Item!",
          icono: "informacion",
        });
        btnCancela.current.focus();
        sigue = false;
      } else if (selected.length === records.length && verificacion === 5) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Usted no ha marcado ningun Item!",
          icono: "informacion",
        });
        btnCancela.current.focus();
        sigue = false;
      } else {
        var search;
        var occurrences;
        var occurrences1;
        for (let i = 0; i < factuSelected.length; i++) {
          search = factuSelected[i].trim().toLowerCase();
          occurrences = factuSelected.filter(function (val) {
            return val.trim().toLowerCase() === search;
          }).length;
          occurrences1 = records.filter(function (val) {
            return val.nrofactura.trim().toLowerCase() === search;
          }).length;
          if (occurrences !== occurrences1) {
            setMensaje({
              mostrar: true,
              titulo: "Error",
              texto:
                "La Factura " +
                factuSelected[i] +
                " Posee mas de una Operacion, debe verificar todas las operaciones de una misma factura para poder procesar esa factura.",
              icono: "error",
            });
            sigue = false;
            break;
          }
        }
      }
    }

    if (sigue && verificacion !== 4) {
      if (verificacion === 1) {
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto:
            "¿Esta Seguro de Procesar estos Movimientos como Verificados ?",
          icono: "confirmacion",
        });
      }
    }
  };

  const blanquear2 = () => {
    setSelected([]);
    setFactuSelected([]);
    setRecords([]);
    setEncontrados([]);
    setNoEncontrados([]);
    setReferenciaCorta([]);
    setNoCoincide([]);
    setTipoImpuesto();
    setVerificacion("");
    setDisabletbtn({
      ...disabletbtn,
      consultar: false,
      verificar: false,
      rechazar: false,
      editar: false,
    });
    setLiquidador("");
    setIdUsuario("");
    setUsuario("");
    setDesabilitarRows(false);
    setDesabilitarRows2(false);
    setSelect2("0");
    setActivo(true);
    setActivo1(true);
    setHabilitarApi({
      show: false,
      modal: false,
      key: null,
      cliente_id: null,
      host: null,
    });
  };

  const cancelar = () => {
    blanquear2();
    setRecords([]);
    if (txtTotal.current) txtTotal.current.value = "0,00";
    // Limpia los valores de los inputs y select
    if (txtFile.current) txtFile.current.value = "";
    if (cmbCuentaBan.current) cmbCuentaBan.current.value = "0";
  };

  const seleccionarPagosAVerificar = (idtiping) => {
    setContar(0);
    setActivate(true);

    let sql1 = " AND idtipoingreso = " + idtiping;
    let condic = "";
    let id = " p.idcuentabancaria > 0 ";

    if (cmbCuentaBan.current.value !== "0") {
      id = " p.idcuentabancaria = " + cmbCuentaBan.current.value;
    }

    if (radioSeleccionarFecha.current.checked) {
      let val2 =
        txtFechaDesde.current.value === ""
          ? "now()"
          : txtFechaDesde.current.value;
      let val3 =
        txtFechaHasta.current.value === ""
          ? "now()"
          : txtFechaHasta.current.value;
      condic =
        " where  Fecha Between" +
        "'" +
        val2 +
        "'" +
        " AND " +
        "'" +
        val3 +
        "' " +
        sql1;
    } else {
      condic = " WHERE true " + sql1;
    }

    selectPagosVerify(id, condic);
  };

  const handlecmbTipoImpuesto = (event) => {
    seleccionarPagosAVerificar(event.target.value);
  };

  const handlecmbCuentaBancaria = (event) => {
    let idtiping = cmbTipoImpuesto.current.value;
    let sql1 = " where true AND idtipoingreso = " + idtiping;
    let id = " p.idcuentabancaria > 0";

    if (event.target.value !== "0") {
      id = " p.idcuentabancaria = " + event.target.value;
    }

    const cuenta = cuentaBancaria.find(
      (item) =>
        item.idcuentabancaria === event.target.value && item.api === true,
    );

    if (cuenta) {
      setHabilitarApi({
        show: cuenta.api,
        modal: false,
        key: cuenta.apikey,
        cliente_id: cuenta.cliente_id,
        host: cuenta.host,
      });
    } else {
      setHabilitarApi({
        show: false,
        modal: false,
        key: null,
        cliente_id: null,
        host: null,
      });
    }

    // selectPagosVerify(id, ' WHERE true  AND idtipoingreso in (1, 11)');
    selectPagosVerify(id, sql1);
  };

  const verificarPagos = async () => {
    setActivate(true);

    try {
      // Crear array de promesas
      const promesas = records.map(async (pago) => {
        console.log(pago);

        let motivo = pago.banco === "44" ? "CI" : "CE";
        if (pago.tipotransaccion === "1") {
          motivo = "CD";
        }
        const numerosArray = pago.nrodocumento.match(/\d+/g);
        const numerosJuntos = numerosArray ? numerosArray.join("") : "";
        const referencia = numerosJuntos.slice(motivo === "CE" ? -8 : -10);
        const fecha = moment.utc(pago.fecha).format("YYYY-MM-DD");
        const monto = parseFloat(pago.monto);

        if ((motivo === "CI" || motivo === "CD") && referencia.length < 10) {
          return {
            ...pago,
            verificado: false,
            motivoFallo: "referencia",
          };
        }

        if (motivo === "CE" && referencia.length < 8) {
          return {
            ...pago,
            verificado: false,
            motivoFallo: "referencia",
          };
        }

        try {
          const response = await axios.post(
            habilitarApi.host,
            {
              cliente_id: habilitarApi.cliente_id,
              referencia,
              fecha,
              motivo,
            },
            {
              headers: {
                Authorization: `Bearer ${habilitarApi.key}`,
              },
            },
          );

          if (
            response.status === 200 &&
            response.data.codigo === 200 &&
            monto === parseFloat(response.data.data.monto)
          ) {
            return {
              ...pago,
              verificado: true,
              dataApi: response.data.data,
              motivoFallo: "",
            };
          }
          return { ...pago, verificado: false, motivoFallo: "monto" };
        } catch (err) {
          return { ...pago, verificado: false, motivoFallo: "404" };
        }
      });

      const settled = await Promise.allSettled(promesas);
      const resultados = settled.map((r, i) =>
        r.status === "fulfilled"
          ? r.value
          : { ...records[i], verificado: false, motivoFallo: "rejected" },
      );

      const verificados = resultados.filter((r) => r.verificado);
      const referencia_corta = resultados.filter(
        (r) => r.motivoFallo === "referencia",
      );
      const no_coincide = resultados.filter((r) => r.motivoFallo === "monto");
      const no_encontrados = resultados.filter((r) => r.motivoFallo === "404");

      setRecords(verificados);
      setEncontrados(verificados);
      setReferenciaCorta(referencia_corta);
      setNoCoincide(no_coincide);
      setNoEncontrados(no_encontrados);

      setTimeout(() => {
        const newSelecteds = verificados.map(
          (n) =>
            n.nrofactura.trim() +
            n.periodo.trim() +
            n.nrodocumento.trim() +
            n.monto.toString().trim(),
        );
        setSelected(newSelecteds);
        const newFacSelecteds = verificados.map((n) => n.nrofactura.trim());
        setFactuSelected(newFacSelecteds);
        sumarMontoFactura(newSelecteds);
      }, 500);
    } catch (error) {
      console.error("Error general:", error);
    } finally {
      setActivate(false);
    }
  };

  const editarMovimiento = (data) => (event) => {
    setOperacion(2);
    setData(data);
    setTipoPago(data.tipo === 1 ? "DEPOSITO" : "TRANSFERENCIA");
    setMostrar5(true);
  };

  const sumarMontoFactura = (regSelected) => {
    var total = parseFloat(0.0);
    for (let x = 0; x < regSelected.length; x++) {
      for (let y = 0; y < records.length; y++) {
        if (
          records[y].nrofactura.trim() +
            records[y].periodo.trim() +
            records[y].nrodocumento.trim() +
            records[y].monto.toString().trim() ===
          regSelected[x]
        ) {
          total = total + parseFloat(records[y].monto);
          break;
        }
      }
    }

    txtTotal.current.value = formatMoneda(
      total.toString().replace(".", ","),
      ",",
      ".",
      2,
    );
  };

  const onChecks = (event) => {
    let ids = (cmbTipoImpuesto.current.value = ""
      ? 1
      : cmbTipoImpuesto.current.value);

    let ingreTipo = ids;
    if (ids === "1") {
      ingreTipo = "1, 11";
    } else if (ids === "2") {
      ingreTipo = "2, 12";
    } else if (ids === "3") {
      ingreTipo = "3, 13";
    }

    let idss = " p.idcuentabancaria > 0 ";

    if (cmbCuentaBan.current.value !== "0") {
      idss = " p.idcuentabancaria = " + cmbCuentaBan.current.value;
    }
    let sql;
    let sql1 = ` AND idtipoingreso in (${ingreTipo})`;
    let val2;
    let val3;

    if (event.target.name === "radiofecha") {
      if (radioTodosDias.current.checked) {
        setSelect2("0");
        sql = " WHERE true " + sql1;
        selectPagosVerify(idss, sql);
      } else if (radioSeleccionarFecha.current.checked) {
        setSelect2("1");
        val2 = "now()";
        val3 = "now()";
        sql =
          " where  Fecha Between" +
          "'" +
          val2 +
          "'" +
          " AND " +
          "'" +
          val3 +
          "' " +
          sql1;
        selectPagosVerify(idss, sql);
      } else {
        setSelect2("0");
      }
    }
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      if (event.target.id === "inputFechaDesde") {
        if (txtFechaDesde.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Fecha Invalida",
            icono: "informacion",
          });
        } else if (
          txtFechaDesde.current.value > txtFechaHasta.current.value &&
          txtFechaHasta.current.value !== ""
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto:
              "La fecha de inicio no puede ser superior a la fecha de fin.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputFechaHasta") {
        if (txtFechaHasta.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Fecha Invalida",
            icono: "informacion",
          });
        } else if (
          txtFechaDesde.current.value > txtFechaHasta.current.value &&
          txtFechaHasta.current.value !== ""
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto:
              "La fecha de fin no puede ser inferior a la fecha de inicio.",
            icono: "informacion",
          });
        } else {
          seleccionarPagosAVerificar(cmbTipoImpuesto.current.value);
        }
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputFechaDesde") {
        if (txtFechaDesde.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Fecha Invalida",
            icono: "informacion",
          });
        } else if (
          txtFechaDesde.current.value > txtFechaHasta.current.value &&
          txtFechaHasta.current.value !== ""
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto:
              "La fecha de inicio no puede ser superior a la fecha de fin.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputFechaHasta") {
        if (txtFechaHasta.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Fecha Invalida",
            icono: "informacion",
          });
        } else if (
          txtFechaDesde.current.value > txtFechaHasta.current.value &&
          txtFechaHasta.current.value !== ""
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto:
              "La fecha de inicio no puede ser superior a la fecha de fin.",
            icono: "informacion",
          });
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const SelectVerificacion = (idverificacion) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/selectverificacionbyid?idverificacion=${idverificacion}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          app: "admin",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);

            if (verificacion === 4 || verificacion === 5) {
              const newSelecteds = response.data.map(
                (n) =>
                  n.nrofactura.trim() +
                  n.periodo.trim() +
                  n.nrodocumento.trim() +
                  n.monto.toString().trim(),
              );
              setSelected(newSelecteds);
              const newFacSelecteds = response.data.map((n) =>
                n.nrofactura.trim(),
              );
              setFactuSelected(newFacSelecteds);
            }
          } else {
            setRecords([]);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const cerrarModalActualizar = () => {
    setMostrar5(false);
  };

  const validarActuPagoW = () => {
    setMostrar5(false);
    onVerificar()
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarSolicitud();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (verificacion === 5) {
      SelectVerificacion(0);
      blanquear2();
    } else {
      let ids = (cmbTipoImpuesto.current.value = ""
        ? 0
        : cmbTipoImpuesto.current.value);

      let ingreTipo = ids;
      if (ids === "1") {
        ingreTipo = "1, 11";
      } else if (ids === "2") {
        ingreTipo = "2, 12";
      } else if (ids === "3") {
        ingreTipo = "3, 13";
      }
      let sql;
      let sql1 = ` AND idtipoingreso in (${ingreTipo})`;
      let idss = "p.idcuentabancaria > 0";
      sql = " WHERE true " + sql1;
      // selectPagosVerify(idss, sql);
      blanquear2();
    }
  };

  const imprimirComprobante = (referencia) => {
    const url = `${op.conexionpagoweb}/imagen?img=${encodeURIComponent(referencia)}`;
    window.open(
      url,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  const imprimirReporte = (value) => {
    let data = [];
    let TITULO = "";
    if (value === "validados") {
      data = encontrados;
      TITULO = "PAGOS VALIDADOS CON EXITO";
    } else if (value === "coincidencias") {
      data = noCoincide;
      TITULO = "PAGOS CON MONTOS QUE NO COINCIDEN";
    } else if (value === "referencias") {
      data = referenciaCorta;
      TITULO = "PAGOS CON REFERENCIAS QUE NO COINCIDEN";
    } else if (value === "404") {
      data = noEncontrados;
      TITULO = "PAGOS NO ENCONTRADOS";
    }

    if (data.length > 0) {
      const reporte = "ReporteVerificacionPaez";
      const verificador =
        (usuario && `${usuario.nombres.trim()} ${usuario.apellidos.trim()}`) ||
        "No especificado";
      const cedula = "";
      const TIPOINGRESO = cmbTipoImpuesto.current.value;
      const CTABANCARIA = cmbCuentaBan.current.value;
      const todosLosIds = data.map((item) => item.idpagoweb);
      const idsString = todosLosIds.join(",");

      window.open(
        op.reportes +
          "/pagosweb?" +
          "reporte=" +
          reporte +
          "&VERIFICADOR=" +
          verificador +
          "&CEDULA=" +
          cedula +
          "&CTABANCARIA=" +
          CTABANCARIA +
          "&TIPOINGRESO=" +
          TIPOINGRESO +
          "&TITULO=" +
          TITULO +
          "&ID=" +
          idsString,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, {
        type: "array",
        cellText: true, // Forzar lectura como texto
        cellDates: true,
      });

      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      // Leer como texto para preservar el formato original
      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false, // Obtener valores como texto
        defval: "",
      });

      let array = [];

      // Función para convertir texto con formato de moneda a número
      const parseMonto = (value) => {
        if (!value) return 0;

        // Si ya es número, retornarlo
        if (typeof value === "number") return value;

        // Si es string, procesar el formato de moneda
        if (typeof value === "string") {
          // Remover cualquier carácter no numérico excepto comas y puntos
          let cleaned = value.replace(/[^\d,]/g, "");

          // Si tiene coma, asumir que es el separador decimal
          if (cleaned.includes(",")) {
            // Reemplazar la coma por punto para parseFloat
            cleaned = cleaned.replace(",", ".");
          }

          const num = parseFloat(cleaned);
          return isNaN(num) ? 0 : num;
        }

        return 0;
      };

      let banco = cmbCuentaBan.current.value;

      if (banco.toString() === "44") {
        for (let i = 1; i < jsonData.length; i++) {
          if (jsonData[i] && jsonData[i].__EMPTY) {
            const monto = jsonData[i].__EMPTY_3;

            array.push({
              nrodocumento: jsonData[i].__EMPTY.toString().trim(),
              monto: parseMonto(monto),
            });
          }
        }
      } else if (banco.toString() === "36") {
        for (let i = 2; i < jsonData.length; i++) {
          if (jsonData[i] && jsonData[i].__EMPTY_1) {
            const monto = jsonData[i].__EMPTY_4;

            const doc = jsonData[i].__EMPTY_1.toString();
            array.push({
              nrodocumento: doc.replace(/'/g, "").slice(-9),
              monto: parseFloat(monto.toString().replace(",", ".")).toFixed(2),
            });
          }
        }
      }

      setRecordsArray(array);
    }
  };

  const handleProcessFile = () => {
    // Capturar datos actuales
    const misRecords = records;
    const miExcel = recordsArray;

    if (!miExcel?.length || !misRecords?.length) {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "No hay datos para procesar",
        icono: "informacion",
      });
      return;
    }

    setActivate(true);
    setRespaldo(misRecords);

    const coincidencias = []; // SOLO las que SÍ coinciden
    let indice = 0;
    const total = misRecords.length;

    const procesarSiguiente = () => {
      const limite = Math.min(indice + 50, total);

      for (indice; indice < limite; indice++) {
        const record = misRecords[indice];
        const docRecord = String(record.nrodocumento).trim();
        const montoRecord = parseFloat(record.monto);

        let encontrado = false; // Bandera para saber si encontramos coincidencia

        for (let x = 0; x < miExcel.length; x++) {
          const excel = miExcel[x];
          const docExcel = String(excel.nrodocumento).trim();
          const montoExcel = parseFloat(excel.monto);

          // TU LÓGICA ORIGINAL
          if (docExcel.length < 9) {
            if (
              docRecord.slice(-docExcel.length) === docExcel &&
              montoRecord === montoExcel
            ) {
              encontrado = true; // ¡SÍ coincide!
              break;
            }
          } else {
            if (
              docRecord.slice(-9) === docExcel.slice(-9) &&
              montoRecord === montoExcel
            ) {
              encontrado = true; // ¡SÍ coincide!
              break;
            }
          }
        }

        // SOLO si encontramos coincidencia, lo agregamos
        if (encontrado) {
          coincidencias.push(record);
        }
        // Si NO encontrado, simplemente NO lo agregamos
      }

      if (indice < total) {
        setTimeout(procesarSiguiente, 0);
      } else {
        setRecords(coincidencias); // Mostramos SOLO los que coinciden
        setActivate(false);
        setIsRecordsLoaded(true);

        setMensaje({
          mostrar: true,
          titulo: "Proceso Completado",
          texto: `Se encontraron ${coincidencias.length} registros que SÍ coinciden`,
          icono: "exito",
        });
      }
    };

    procesarSiguiente();
  };

  useEffect(() => {
    if (parseInt(verificacion) === 1) {
      let ids = (cmbTipoImpuesto.current.value = ""
        ? 1
        : cmbTipoImpuesto.current.value);

      let ingreTipo = ids;
      if (ids === "1") {
        ingreTipo = "1, 11";
      } else if (ids === "2") {
        ingreTipo = "2, 12";
      } else if (ids === "3") {
        ingreTipo = "3, 13";
      }

      let sql;
      let sql1 = ` AND idtipoingreso in (${ingreTipo})`;
      sql = " WHERE true " + sql1;
    }
  }, [verificacion]);

  useEffect(() => {
    if (isRecordsLoaded === true) {
      const simulatedEvent = { target: { checked: true } };
      handleSelectAllClick(simulatedEvent);
      setIsRecordsLoaded(false);
    }
  }, [isRecordsLoaded]);

  useEffect(() => {
    SelectCuentaBanco();
    setDesabilitarRows(false);
  }, []);

  return (
    <div className="py-3">
      <div className="container col-md-12">
        <fieldset className="row border-azul rounded mx-auto col-md-12 p-3">
          <legend className="float-none m-0 w-auto px-2 fs-6">
            Datos del Verificador
          </legend>

          <div className="row g-2 align-items-center">
            {/* Código del verificador */}

            <div className="d-flex align-items-center col-md-2 my-auto">
              <label className="form-label fw-bold mb-0 me-1">Código:</label>
              <span className="text-muted">{idusuario || "N/A"}</span>
            </div>

            {/* Nombre del verificador */}

            <div className="d-flex align-items-center col-md-5 my-auto">
              <label className="form-label fw-bold mb-0 me-1">
                Nombres y Apellidos:
              </label>
              <span className="text-muted">
                {usuario
                  ? `${usuario.nombres.trim()} ${usuario.apellidos.trim()}`
                  : liquidador || "No especificado"}
              </span>
            </div>

            {/* Fecha actual */}

            <div className="d-flex my-auto align-items-center col-md-2">
              <label className="form-label fw-bold mb-0 me-1">Fecha:</label>
              <span className="text-muted">
                {moment.utc(fechaSistema).format("DD-MM-YYYY")}
              </span>
            </div>

            <div className="input-group input-group-sm mb-2 col-md-3 px-0">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                {" "}
                Tipo de Impuesto:
              </span>
              <select
                name=""
                disabled={
                  verificacion === 0 ||
                  verificacion === "" ||
                  verificacion === 5
                    ? true
                    : false
                }
                ref={cmbTipoImpuesto}
                onChange={handlecmbTipoImpuesto}
                className="form-select text-center"
              >
                {tipoImpuesto &&
                  tipoImpuesto.map((impu) => (
                    <option
                      key={impu.idtipoimpuesto}
                      value={impu.idtipoingreso}
                    >
                      {impu.descripcion.trim()}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </fieldset>

        <div className="col-md-12 my-auto mx-auto row mt-3 py-2">
          <div className="col-md-4">
            <select
              name=""
              ref={cmbCuentaBan}
              style={{ marginBottom: "5px" }}
              className="form-control form-control-sm"
              onChange={handlecmbCuentaBancaria}
              disabled={
                verificacion === 0 || verificacion === "" || verificacion === 5
                  ? true
                  : false
              }
            >
              <option key="0" value="0">
                Todas las Cuentas
              </option>
              {cuentaBancaria &&
                cuentaBancaria.map((cta) => (
                  <option
                    key={cta.idcuentabancaria}
                    value={cta.idcuentabancaria}
                  >
                    {cta.nombre + " " + cta.cuentabancaria}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-md-2">
            {habilitarApi.show && (
              <button
                onClick={verificarPagos}
                className="btn btn-sm btn-success"
              >
                <i className="fas fa-sync"> Validar Pagos</i>
              </button>
            )}
          </div>
          <div className="col-md-2">
            {habilitarApi.show && (
              <button
                onClick={() => {
                  setHabilitarApi({ ...habilitarApi, modal: true });
                }}
                className="btn btn-sm btn-outline-primary"
              >
                <i className="fas fa-search"> CONSULTAR PAGO</i>
              </button>
            )}
          </div>
          <div className="col-md-4 input-group input-group-sm">
            <input
              disabled={
                verificacion === 0 || verificacion === "" || verificacion === 5
                  ? true
                  : false
              }
              type="file"
              className="form-control form-control-sm my-auto"
              onChange={handleFileChange}
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              ref={txtFile}
            />
            <button
              disabled={
                verificacion === 0 || verificacion === "" || verificacion === 5
                  ? true
                  : false
              }
              onClick={handleProcessFile}
              className="btn btn-primary btn-sm my-auto"
            >
              Procesar Archivo
            </button>
          </div>
        </div>

        <fieldset className="row border-azul rounded mx-auto col-md-12">
          <legend className="float-none m-0 w-auto">Movimientos Web</legend>

          <div className="row m-0 col-12 py-2">
            <div className="col-sm-12 col-12 mb-1 py-auto">
              <input
                type="text"
                onChange={handleSearch}
                className="form-control form-control-sm rounded-pill col-md-3 my-auto"
                placeholder="Buscar"
              />
            </div>

            <div className="col-md-12 mx-auto row">
              <div className="row m-0 col-sm-12 col-12">
                <div className="form-check col-sm-2 my-auto py-auto">
                  <input
                    className="my-auto form-check-input"
                    name="radiofecha"
                    value="1"
                    id="radioSi"
                    disabled={
                      verificacion === 0 ||
                      verificacion === "" ||
                      verificacion === 5
                        ? true
                        : false
                    }
                    defaultChecked={true}
                    ref={radioTodosDias}
                    onChange={onChecks}
                    type="radio"
                  />
                  <label
                    className="my-auto form-check-label"
                    htmlFor="exampleRadi4"
                  >
                    Todos
                  </label>
                </div>
                <div className="form-check col-sm-2 my-auto py-auto">
                  <input
                    className="my-auto form-check-input"
                    name="radiofecha"
                    value="2"
                    id="radioNo"
                    disabled={
                      verificacion === 0 ||
                      verificacion === "" ||
                      verificacion === 5
                        ? true
                        : false
                    }
                    ref={radioSeleccionarFecha}
                    onChange={onChecks}
                    type="radio"
                  />
                  <label
                    className="my-auto form-check-label"
                    htmlFor="exampleRadi5"
                  >
                    Por Fecha
                  </label>
                </div>

                {select2 === "1" && (
                  <div className="col-sm-4 row m-0">
                    <div className="input-group input-group-sm col-sm-5 px-0">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Desde:
                      </label>
                      <input
                        type="date"
                        className="form-control text-uppercase"
                        aria-label="Sizing example input"
                        name="fecha"
                        ref={txtFechaDesde}
                        max={moment.utc(fechaSistema).format("YYYY-MM-DD")}
                        id="inputFechaDesde"
                        defaultValue={moment
                          .utc(fechaSistema)
                          .format("YYYY-MM-DD")}
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div className="input-group input-group-sm col-sm-5 px-1">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Hasta:
                      </label>
                      <input
                        type="date"
                        className="form-control text-uppercase"
                        aria-label="Sizing example input"
                        name="fecha"
                        ref={txtFechaHasta}
                        max={moment.utc(fechaSistema).format("YYYY-MM-DD")}
                        id="inputFechaHasta"
                        defaultValue={moment
                          .utc(fechaSistema)
                          .format("YYYY-MM-DD")}
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div style={{ height: "300px", overflowY: "auto" }}>
            <table
              className="table table-striped table-hover table-sm border-table"
              aria-labelledby="tableTitle"
              size="small"
              aria-label="enhanced table"
              style={{ width: "100%" }}
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={"asc"}
                orderBy={"calories"}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={records.length}
                headCells={headCells}
                verificacion={verificacion}
              />
              <tbody>
                {filterFn.fn(records).map((row) => {
                  const isItemSelected = isSelected(
                    row.nrofactura.trim() +
                      row.periodo.trim() +
                      row.nrodocumento.trim() +
                      row.monto.toString().trim(),
                  );
                  return (
                    <tr
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={
                        row.nrofactura.trim() +
                        row.periodo.trim() +
                        row.nrodocumento.trim() +
                        row.monto.toString().trim()
                      }
                      selected={isItemSelected}
                    >
                      <td
                        className="align-middle"
                        style={{
                          textAlign: "center",
                          padding: 0,
                          borderRight: "#cbced1 1px solid",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={isItemSelected}
                          disabled={desabilitarRows2}
                          onChange={(event) =>
                            handleClick(
                              event,
                              row.nrofactura.trim() +
                                row.periodo.trim() +
                                row.nrodocumento.trim() +
                                row.monto.toString().trim(),
                              row.nrofactura.trim(),
                            )
                          }
                        />
                      </td>
                      <td
                        className="align-middle"
                        style={{
                          padding: 0,
                          paddingLeft: 5,
                          textAlign: "left",
                          fontSize: "10px",
                          borderRight: "#cbced1 1px solid",
                        }}
                      >
                        {row.contribuyente}{" "}
                      </td>
                      <td
                        className="align-middle"
                        style={{
                          padding: 0,
                          paddingLeft: 5,
                          textAlign: "left",
                          fontSize: "10px",
                          borderRight: "#cbced1 1px solid",
                        }}
                      >
                        {row.rif}{" "}
                      </td>
                      <td
                        className="align-middle"
                        style={{
                          padding: 0,
                          paddingLeft: 5,
                          textAlign: "left",
                          fontSize: "10px",
                          borderRight: "#cbced1 1px solid",
                        }}
                      >
                        {row.cuentabancaria.trim()}
                      </td>
                      <td
                        className="align-middle"
                        style={{
                          padding: 0,
                          textAlign: "center",
                          fontSize: "10px",
                          borderRight: "#cbced1 1px solid",
                        }}
                      >
                        {row.nrodocumento.trim()}
                      </td>
                      <td
                        className="align-middle"
                        style={{
                          padding: 0,
                          textAlign: "center",
                          fontSize: "10px",
                          borderRight: "#cbced1 1px solid",
                        }}
                      >
                        {row.tipo}
                      </td>
                      <td
                        className="align-middle"
                        style={{
                          padding: 0,
                          textAlign: "center",
                          fontSize: "10px",
                          borderRight: "#cbced1 1px solid",
                        }}
                      >
                        {moment.utc(row.fecha).format("DD/MM/YYYY")}
                      </td>
                      <td
                        className="align-middle"
                        style={{
                          padding: 0,
                          paddingRight: 5,
                          textAlign: "right",
                          borderRight: "#cbced1 1px solid",
                          fontSize: "10px",
                        }}
                      >
                        {formatMoneda(
                          row.monto.toString().replace(".", ","),
                          ",",
                          ".",
                          2,
                        )}
                      </td>
                      <td
                        className="align-middle"
                        style={{
                          padding: 0,
                          textAlign: "center",
                          fontSize: "10px",
                          borderRight: "#cbced1 1px solid",
                        }}
                      >
                        {row.nrofactura.trim()}
                      </td>
                      <td
                        className="align-middle"
                        style={{
                          padding: 0,
                          textAlign: "center",
                          fontSize: "10px",
                          borderRight: "#cbced1 1px solid",
                        }}
                      >
                        {row.periodo.trim()}
                      </td>
                      <td
                        className="align-middle"
                        style={{
                          padding: 0,
                          textAlign: "center",
                          fontSize: "10px",
                          borderRight: "#cbced1 1px solid",
                        }}
                      >
                        {moment.utc(row.fecha).format("DD/MM/YYYY")}
                      </td>
                      <td
                        className="align-middle"
                        align="center"
                        style={{ padding: 2, textAlign: "center" }}
                      >
                        <button
                          disabled={desabilitarRows}
                          onClick={editarMovimiento(row)}
                          className="btn btn-sm mx-1 btn-warning rounded-circle "
                        >
                          <i className="fas fa-edit"> </i>{" "}
                        </button>
                        {row.documen && row.documen !== "" && (
                          <button
                            disabled={desabilitarRows}
                            onClick={() => imprimirComprobante(row.documen)}
                            className="btn btn-sm mx-1 btn-primary rounded-circle "
                          >
                            <i className="fas fa-file-pdf"> </i>{" "}
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="row col-md-12 py-1">
            <div className="input-group input-group-sm col-md-2">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Total:
              </span>
              <input
                type="text"
                readOnly
                ref={txtTotal}
                className="form-control form-control-sm text-right"
                defaultValue="0,00"
                id="inputTotal"
              />
            </div>

            <div className="col-md-10 ml-auto d-flex justify-content-end">
              {habilitarApi.show && (
                <button
                  onClick={() => imprimirReporte("validados")}
                  className="btn btn-sm btn-info my-auto btn-success mx-2"
                >
                  <i className="fas fa-print">
                    {" "}
                    Validados: {encontrados.length}
                  </i>
                </button>
              )}
              {habilitarApi.show && (
                <button
                  onClick={() => imprimirReporte("coincidencias")}
                  className="btn btn-sm btn-info my-auto btn-success mx-2"
                >
                  <i className="fas fa-print">
                    {" "}
                    Por Monto: {noCoincide.length}
                  </i>
                </button>
              )}
              {habilitarApi.show && (
                <button
                  onClick={() => imprimirReporte("referencias")}
                  className="btn btn-sm btn-info my-auto btn-success mx-2"
                >
                  <i className="fas fa-print">
                    {" "}
                    Por Referencia: {referenciaCorta.length}
                  </i>
                </button>
              )}
              {habilitarApi.show && (
                <button
                  onClick={() => imprimirReporte("404")}
                  className="btn btn-sm btn-info my-auto btn-success mx-2"
                >
                  <i className="fas fa-print">
                    {" "}
                    No Encontrados: {noEncontrados.length}
                  </i>
                </button>
              )}
              {!activo && (
                <button
                  type="button"
                  onClick={onChangeValidar}
                  className="btn btn-sm my-auto btn-success mx-2 "
                >
                  <i className="fas fa-check-circle"> Aceptar</i>
                </button>
              )}
              {!activo1 && (
                <button
                  type="button"
                  onClick={cancelar}
                  className="btn btn-sm my-auto btn-danger mx-2 "
                >
                  <i className="fas fa-window-close"> Cancelar</i>
                </button>
              )}
              {!disabletbtn.verificar && (
                <button
                  type="button"
                  disabled={disabletbtn.verificar}
                  onClick={onVerificar}
                  className="btn btn-sm btn-success my-auto"
                >
                  <i className="fas fa-check-circle"> Verificar</i>
                </button>
              )}
            </div>
          </div>
        </fieldset>
      </div>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} />
      <ActualizarPagosWeb
        show={mostrar5}
        onHideCancela={cerrarModalActualizar}
        onHideAcepta={validarActuPagoW}
        cuentabancaria={cuentaBancaria}
        data={data}
        deshabilitado={false}
        tipopago={tipoPago}
        operacion={operacion}
      />

      <ModalBancamiga
        show={habilitarApi.modal}
        api={habilitarApi}
        onHide={() => setHabilitarApi({ ...habilitarApi, modal: false })}
      />
    </div>
  );
}

export default TablaVerificarPagosEstadoCuenta;
